import React from "react";
import { ArrowRight } from "lucide-react";
import { ButtonLink } from "../../../../components/ui/button";
import { FadeUp } from "./FadeUp";
import type { RouteMap } from "../../types";

type CTASectionProps = {
  routes: RouteMap;
};

export const CTASection: React.FC<CTASectionProps> = ({ routes }) => (
  <section className="py-24 bg-premium-500 relative overflow-hidden">
    <div
      className="absolute inset-0 opacity-40"
      style={{
        backgroundImage:
          "radial-gradient(circle at 2px 2px, white 1px, transparent 0)",
        backgroundSize: "32px 32px",
      }}
    />

    <div className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
      <FadeUp>
        <h2 className="text-4xl md:text-5xl lg:text-6xl font-extrabold text-white mb-6 tracking-tight font-display">
          Chat for a minute. Go live.
        </h2>

        <div className="flex flex-col sm:flex-row justify-center items-center gap-6">
          <ButtonLink
            to={routes.signup}
            variant="secondary"
            size="lg"
            className="bg-card text-premium-600 hover:bg-muted px-10 py-4 rounded-xl font-bold text-xl shadow-xl flex items-center hover:scale-105 active:scale-95 w-full sm:w-auto justify-center"
          >
            Start 30-day trial
            <ArrowRight className="w-6 h-6 ml-3" />
          </ButtonLink>
        </div>
        <p className="text-white/70 mt-6 text-sm font-medium">
          30-day trial covers the full suite. Then $9/month. Cancel anytime.
        </p>
      </FadeUp>
    </div>
  </section>
);
